import React from 'react';
import { NoDataContent } from '@lk-gtcom/ecomlab-components';
import './HistoryTask.scss'
const parse = require('html-react-parser');

interface LogItem {
    id: string | number;
    text: string | string[];
    created_at?: string;
}

// Типизация пропсов компонента
interface HistoryTaskProps {
    logsArr?: LogItem[];
    onParse?: (text: string) => string; 
}

// Функция для безопасного парсинга текста
const safeParse = (text: string): string => {
    if (typeof parse === 'function') {
        try {
            return parse(text);
        } catch (error) {
            console.error('Parse error:', error);
            return text;
        }
    }
    return text;
};

const HistoryTask: React.FC<HistoryTaskProps> = ({
    logsArr = [],
    onParse = safeParse
}) => {
    return (
        <div className="history-actions__content">
            {logsArr.length > 0 ?
                logsArr.map((el) => {
                    const { id, text, created_at } = el;

                    return <div key={id} className="history-task">
                        <div className="history-task__info">
                            {Array.isArray(text) ? (
                                text.map((item, idx) => (
                                    <p key={idx} className="history-task__text-value">
                                        {item}
                                    </p>
                                ))
                            ) : (
                                <p className="history-task__text-value">
                                    {onParse(text)}
                                </p>
                            )}
                        </div>

                        {created_at && (
                            <p className="history-task__text-date">
                                {new Date(created_at).toLocaleDateString('ru-RU', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: '2-digit',
                                    hour: 'numeric',
                                    minute: 'numeric',
                                })}
                            </p>
                        )}
                    </div>
                        ;
                })
                :
                <NoDataContent
                    height="100%"
                    title="Ничего не найдено"
                    border={false}
                />
            }
        </div>
    );
};

export default HistoryTask;